import widgetInfo from './widgetInfo';
import layout from './layout';
import compareVehicles from './compare';
import modalSettings from './modalSettings';
import offSiteData from './offSiteData';
import userProfile from './userProfile';

const root = {
	widgetInfo,
	layout,
	compareVehicles,
	modalSettings,
	offSiteData,
	userProfile
};

export default root;
